import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQueryWithAuth = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + "api/",
    prepareHeaders: (headers) => {
        const token = localStorage.getItem('token');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        headers.set('Content-Type', 'application/json');
        return headers;
    },
    responseHandler: async (response) => {
        const text = await response.text();
        try {
            return JSON.parse(text);
        } catch (error) {
            if (!response.ok) {
                throw new Error(text);
            }
            return text;
        }
    },
});

export const newsUzbApi = createApi({
    reducerPath: 'newsUzbApi',
    baseQuery: baseQueryWithAuth,
    tagTypes: ['News'],
    endpoints: (builder) => ({
        createNewUzb: builder.mutation({
            query: (news) => ({
                url: '/NewsUzb/CreatNewUzb',
                method: 'POST',
                body: news,
            }),
            invalidatesTags: [{ type: 'News', id: 'LIST' }],
        }),
        updateNewUzb: builder.mutation({
            query: (news) => ({
                url: `/NewsUzb/UpdateNewUzb`,
                method: 'PUT',
                body: news,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'News', id }],
        }),
        getNewUzbById: builder.query({
            query: (id) => `/NewsUzb/GetNewUzb?id=${id}`,
            providesTags: (result, error, id) => [{ type: 'News', id }],
        }),
        getAllNewsUzb: builder.query({
            query: ({ pageSize, pageIndex }) => `/NewsUzb/GetAllNewsUzb?pageSize=${pageSize}&pageIndex=${pageIndex}`,
            providesTags: (result) =>
                result ?
                    [...result.map(({ id }) => ({ type: 'News', id })), { type: 'News', id: 'LIST' }]
                    : [{ type: 'News', id: 'LIST' }],
        }),
    }),
});

export const {
    useCreateNewUzbMutation,
    useUpdateNewUzbMutation,
    useGetNewUzbByIdQuery,
    useGetAllNewsUzbQuery
} = newsUzbApi;